import { localize } from "utils/localizer";

const i18n = {
    addresseeName: {
        en: "Addressee name",
        de: "Ansprechpartner",
    },
    anErrorOccurred: {
        en: "An error occurred",
        de: "Ein Fehler ist aufgetreten",
    },
    back: {
        en: "Back",
        de: "Zurück",
    },
    city: {
        en: "City",
        de: "Stadt",
    },
    clubKey: {
        en: "Location key",
        de: "Sportstätten-Schlüssel",
    },
    CompanyKey: {
        en: "Company key",
        de: "Firmenschlüssel",
    },
    clubName: {
        en: "Location name",
        de: "Sportstätten-Name",
    },
    companyName: {
        en: "Company name",
        de: "Unternehmens-Name",
    },
    country: {
        en: "Country",
        de: "Land",
    },
    createAccount: {
        en: "Create a new user account that will be assigned to the company.",
        de: "Erstelle ein neues Benutzerkonto, das dem Unternehmen zugeordnet wird.",
    },
    emailAddress: {
        en: "E-Mail Address",
        de: "E-Mail Adresse",
    },
    finish: {
        en: "Finish",
        de: "Fertig",
    },
    firstName: {
        en: "First Name",
        de: "Vorname",
    },
    fromAddress: {
        en: "From Address",
        de: "Von Adresse",
    },
    lastName: {
        en: "Last Name",
        de: "Nachname",
    },
    latitude: {
        en: "Latitude",
        de: "Breitengrad",
    },
    login: {
        en: "Login",
        de: "Anmelden",
    },
    loggedInAs: {
        en: (name: string) => `Logged in as: ${name}`,
        de: (name: string) => `Eingeloggt als: ${name}`,
    },
    longitude: {
        en: "Longitude",
        de: "Längengrad",
    },
    mainSportForm: {
        en: "Main sport form",
        de: "Hauptsportart",
    },
    next: {
        en: "Next",
        de: "Weiter",
    },
    password: {
        en: "Password",
        de: "Passwort",
    },
    postalCode: {
        en: "Postal code",
        de: "Postleitzahl",
    },
    registerClub: {
        en: "Register location at PLAYSPORTS",
        de: "Sportstätte bei PLAYSPORTS registrieren",
    },
    registerCompany: {
        en: "Register your company with PLAYSPORTS",
        de: "Unternehmen bei PLAYSPORTS registrieren",
    },
    registerClubIntro: {
        en: "",
        de: "Erstelle in wenigen Minuten deine Sportstätte und teste kostenlos und ohne Risiko unser PLAYSPORTS-Dashboard und unsere App!",
    },
    registerCompanyIntro: {
        en: "Create your company in a few minutes and test our PLAYSPORTS dashboard for employee management and our app for free and without obligation!",
        de: "Erstelle in wenigen Minuten dein Unternehmen und teste kostenlos und unverbindlich unser PLAYSPORTS-Dashboard zur Mitarbeiterverwaltung und unsere App!",
    },
    registerClubSteps: {
        en: [
            "Information about location",
            "Assign addressee",
        ],
        de: [
            "Informationen zur Sportstätte",
            "Ansprechpartner festlegen",
        ],
    },
    registerCompanySteps: {
        en: [
            "Company information",
            "Assign addressee",
        ],
        de: [
            "Informationen zum Unternehmen",
            "Ansprechpartner festlegen",
        ],
    },
    registerSuccess: {
        en: "Location registered successfully",
        de: "Sportstätte erfolgreich registriert",
    },
    registerCompanySuccess: {
        en: "Location registered successfully",
        de: "Unternehmen erfolgreich registriert",
    },
    save: {
        en: "Save",
        de: "Speichern",
    },
    shortName: {
        en: "Short / Display name",
        de: "Kurz-/Anzeigename",
    },
    stateOrProvince: {
        en: "State",
        de: "Bundesland",
    },
    street: {
        en: "Street",
        de: "Straße",
    },
    timeZone: {
        en: "Time zone",
        de: "Zeitzone",
    },
    useExistingAccount: {
        en: "Use existing account",
        de: "Vorhandenen Account benutzen",
    },
    useOtherAccount: {
        en: "Use other account",
        de: "Anderen Account benutzen",
    },
    whatsNext: {
        en: "We have successfully received your registration request. You will be redirected in a moment...",
        de: "Deine Anfrage wurde erfolgreich übermittelt. Du wirst gleich automatisch weitergeleitet...",
    },
    whatsNextCompany: {
        en: "Thank you very much and welcome to PLAYSPORTS MOVE! You will shortly receive an email with your login details and further information on managing of your company. You can find the staff management dashboard here:",
        de: "Vielen Dank und willkommen bei PLAYSPORTS MOVE! Du bekommst in Kürze eine E-Mail mit deinen Zugangsdaten und weiteren Informationen zur Verwaltung deines Unternehmens. Das Dashboard zur Mitarbeiterverwaltung findest du hier: ",
    },
    confirmSignup: {
        en: "Confirm Signup",
        de: "Anmeldung bestätigen",
    },
    confirmSignupDesc: {
        en: "Please provide the confirmation code sent in your email",
        de: "Bitte geben Sie den in Ihrer E-Mail gesendeten Bestätigungscode an",
    },
    confirmSignupCodeSentDesc: {
        en: "Confirmation code resent successfully",
        de: "Bestätigungscode erfolgreich erneut gesendet",
    },
    confirmationCodeRequired: {
        en: "Please enter the confirmation code",
        de: "Bitte geben Sie den Bestätigungscode ein",
    },
    verificationCode: {
        en: "Verfication code",
        de: "Bestätigungs-Code",
    },
    resendVerificationCode: {
        en: "Resend Verfication Code",
        de: "Bestätigungscode nochmal versenden",
    },
    code: {
        en: "Code",
        de: "Code",
    },
    cancel: {
        en: "Cancel",
        de: "Abbrechen",
    },
    confirm: {
        en: "Confirm",
        de: "Bestätigen",
    },
};

export default localize(i18n);
